import { NocApiClient } from '@nocowanie/noc-api';

import { environment } from '@app/environments/environment';

const nocApiConfig = {
    BASE: environment.NOC_API_END_POINT,
};

export const sharedNocApiClient = new NocApiClient(nocApiConfig);

/**
 * NOP grants the mobile offer discount based on the User-Agent of the API call and nocapi
 * forwards ours to it (LR-342). Calls made on the server therefore have to carry the guest
 * User-Agent explicitly, otherwise every server rendered visitor is priced as a desktop one.
 * In the browser the shared client is enough - fetch sets the real User-Agent itself and is
 * not allowed to override it.
 */
export const getNocApiClientForGuest = (userAgent?: string | null): NocApiClient =>
    userAgent
        ? new NocApiClient({ ...nocApiConfig, HEADERS: { 'User-Agent': userAgent } })
        : sharedNocApiClient;
